import axios from "../utils/axios";

const hasAuthToken = () => Boolean(localStorage.getItem("sva_webapp_token"));

export const chatbotApi = {
  sendMessage: async (message, sessionId, image = null) => {
    const endpoint = hasAuthToken() ? "chat" : "chat/public";
    const body = {
      message,
      session_id: sessionId,
    };

    if (image) {
      const [header, base64] = image.split(",");
      body.image = base64;
      body.image_type = header?.split(";")?.[0]?.split(":")?.[1] ?? "image/jpeg";
    }

    const response = await axios.post(endpoint, body);
    return response.data;
  },

  getHistory: async () => {
    const response = await axios.get("chat/history");
    return response.data;
  },

  getSession: async (sessionId) => {
    const response = await axios.get(`chat/session/${sessionId}`);
    return response.data;
  },

  closeSession: async (sessionId) => {
    const response = await axios.post(`chat/session/${sessionId}/close`);
    return response.data;
  },
};

